<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Your Gift Makes A Difference At Camp Dror">
            <h3 style="color: black; text-transform: none; font-size: 16px; line-height: 1.5;">We/I want to support children’s Torah learning throughout the year.<br>  Here is our gift for Camp Dror’s Parnes HaYom program.</h3>
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD', 'ILS']" />
            </FormRow>
            <AmountSelectorList />
            <ErrorLabel field="amount" />
            <TransactionFee />
            </FormSection>
            <FormSection title="Extra Info">
            <br />
            <InHonorOf />
            <br />

            <FormRow inline style="margin-bottom: 0px">
              <FormLabel for="date">
                Dedicate a specific date?
              </FormLabel>
            </FormRow>
            <FormRow>
              <input
                id="date"
                type="date"
                class="date-input"
                @change="setDailyDate(new Date($event.target.value))"
              />
            </FormRow>
            <br />
            <FormRow>
              <FormLabel for="anonymousCheck">
                <input
                  type="checkbox"
                  id="anonymousCheck"
                  :checked="getValue('custom.anonymous') === 'yes'"
                  @click="setValue('custom.anonymous', $event.target.checked ? 'yes' : 'no')"
                /> Make my donation anonymous
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow>             
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
              <Receipt />
            </FormRow>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
          <p class="note">
            <br />All donations are tax-deductible to the full extent permitted by law.
          </p>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue, form } = usePaymentForm();
    onMounted(() => {
      setValue('gateway', 'SensepassCardcomMercazi');
    });

    function setDailyDate(date: Date) {
      setValue(
        "custom.date",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
    }

    return {
      getValue,
      setValue,
      form,
      setDailyDate,
    };
  },
});
</script>


<style scoped lang="scss">
::v-deep .form-container.ou-donation-form{
    margin: 0px auto 20px;
    font-weight: 400;
    @media only screen and (min-width: 720px) {
      margin: 0px auto 40px;
    }
}
::v-deep label{
  font-size: 14px;
    color: #222;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
    margin-bottom: 0px;
}
::v-deep hr {
    margin-bottom: 15px;
    margin-top: 0;
    border: 0;
    height: 0;
    border-top: 1px solid #efefef;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: bold;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}
</style>
